import { createSlice } from "@reduxjs/toolkit";
import { onBoardingApi } from "../api/onboarding.api";
import { TCompanySize, TSector, TLanguage } from "../../types/types";

interface OnBoardingState {
  companySizes: TCompanySize[];
  sectors: TSector[];
  languages: TLanguage[];
}

const initialState: OnBoardingState = {
  companySizes: [],
  sectors: [],
  languages: [],
};

const onBoardingSlice = createSlice({
  name: "onBoarding",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      onBoardingApi.endpoints.getCompanySizes.matchFulfilled,
      (state, { payload }) => {
        state.companySizes = payload;
      }
    );
    builder.addMatcher(
      onBoardingApi.endpoints.getSectors.matchFulfilled,
      (state, { payload }) => {
        state.sectors = payload;
      }
    );
  },
});

export const { reducer, actions } = onBoardingSlice;
export default reducer;
